/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as DefinirContrasenaRouteImport } from './routes/definir-contrasena'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as RecuperarRouteImport } from './routes/recuperar'
import { Route as AuthIndexRouteImport } from './routes/_auth.index'
import { Route as AuthAdminAuditoriaRouteImport } from './routes/_auth.admin.auditoria'
import { Route as AuthAdminCategoriasRouteImport } from './routes/_auth.admin.categorias'
import { Route as AuthAdminOrganizacionesRouteImport } from './routes/_auth.admin.organizaciones'
import { Route as AuthAdminTagsRouteImport } from './routes/_auth.admin.tags'
import { Route as AuthAdminUsuariosRouteImport } from './routes/_auth.admin.usuarios'
import { Route as AuthInsightsIndexRouteImport } from './routes/_auth.insights.index'
import { Route as AuthInsightsIdRouteImport } from './routes/_auth.insights.$id'
import { Route as AuthAdminEstudiosIndexRouteImport } from './routes/_auth.admin.estudios.index'
import { Route as AuthAdminEstudiosIdRouteImport } from './routes/_auth.admin.estudios.$id'
import { Route as AuthAdminEstudiosNuevoRouteImport } from './routes/_auth.admin.estudios.nuevo'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DefinirContrasenaRoute = DefinirContrasenaRouteImport.update({
  id: '/definir-contrasena',
  path: '/definir-contrasena',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const RecuperarRoute = RecuperarRouteImport.update({
  id: '/recuperar',
  path: '/recuperar',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminAuditoriaRoute = AuthAdminAuditoriaRouteImport.update({
  id: '/admin/auditoria',
  path: '/admin/auditoria',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminCategoriasRoute = AuthAdminCategoriasRouteImport.update({
  id: '/admin/categorias',
  path: '/admin/categorias',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminOrganizacionesRoute = AuthAdminOrganizacionesRouteImport.update({
  id: '/admin/organizaciones',
  path: '/admin/organizaciones',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminTagsRoute = AuthAdminTagsRouteImport.update({
  id: '/admin/tags',
  path: '/admin/tags',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminUsuariosRoute = AuthAdminUsuariosRouteImport.update({
  id: '/admin/usuarios',
  path: '/admin/usuarios',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInsightsIndexRoute = AuthInsightsIndexRouteImport.update({
  id: '/insights/',
  path: '/insights/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInsightsIdRoute = AuthInsightsIdRouteImport.update({
  id: '/insights/$id',
  path: '/insights/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminEstudiosIndexRoute = AuthAdminEstudiosIndexRouteImport.update({
  id: '/admin/estudios/',
  path: '/admin/estudios/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminEstudiosIdRoute = AuthAdminEstudiosIdRouteImport.update({
  id: '/admin/estudios/$id',
  path: '/admin/estudios/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminEstudiosNuevoRoute = AuthAdminEstudiosNuevoRouteImport.update({
  id: '/admin/estudios/nuevo',
  path: '/admin/estudios/nuevo',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/definir-contrasena': typeof DefinirContrasenaRoute
  '/entrar': typeof EntrarRoute
  '/recuperar': typeof RecuperarRoute
  '/admin/auditoria': typeof AuthAdminAuditoriaRoute
  '/admin/categorias': typeof AuthAdminCategoriasRoute
  '/admin/organizaciones': typeof AuthAdminOrganizacionesRoute
  '/admin/tags': typeof AuthAdminTagsRoute
  '/admin/usuarios': typeof AuthAdminUsuariosRoute
  '/insights/$id': typeof AuthInsightsIdRoute
  '/insights/': typeof AuthInsightsIndexRoute
  '/admin/estudios/$id': typeof AuthAdminEstudiosIdRoute
  '/admin/estudios/nuevo': typeof AuthAdminEstudiosNuevoRoute
  '/admin/estudios/': typeof AuthAdminEstudiosIndexRoute
}
export interface FileRoutesByTo {
  '/definir-contrasena': typeof DefinirContrasenaRoute
  '/entrar': typeof EntrarRoute
  '/recuperar': typeof RecuperarRoute
  '/': typeof AuthIndexRoute
  '/admin/auditoria': typeof AuthAdminAuditoriaRoute
  '/admin/categorias': typeof AuthAdminCategoriasRoute
  '/admin/organizaciones': typeof AuthAdminOrganizacionesRoute
  '/admin/tags': typeof AuthAdminTagsRoute
  '/admin/usuarios': typeof AuthAdminUsuariosRoute
  '/insights/$id': typeof AuthInsightsIdRoute
  '/insights': typeof AuthInsightsIndexRoute
  '/admin/estudios/$id': typeof AuthAdminEstudiosIdRoute
  '/admin/estudios/nuevo': typeof AuthAdminEstudiosNuevoRoute
  '/admin/estudios': typeof AuthAdminEstudiosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/definir-contrasena': typeof DefinirContrasenaRoute
  '/entrar': typeof EntrarRoute
  '/recuperar': typeof RecuperarRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/admin/auditoria': typeof AuthAdminAuditoriaRoute
  '/_auth/admin/categorias': typeof AuthAdminCategoriasRoute
  '/_auth/admin/organizaciones': typeof AuthAdminOrganizacionesRoute
  '/_auth/admin/tags': typeof AuthAdminTagsRoute
  '/_auth/admin/usuarios': typeof AuthAdminUsuariosRoute
  '/_auth/insights/$id': typeof AuthInsightsIdRoute
  '/_auth/insights/': typeof AuthInsightsIndexRoute
  '/_auth/admin/estudios/$id': typeof AuthAdminEstudiosIdRoute
  '/_auth/admin/estudios/nuevo': typeof AuthAdminEstudiosNuevoRoute
  '/_auth/admin/estudios/': typeof AuthAdminEstudiosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/definir-contrasena'
    | '/entrar'
    | '/recuperar'
    | '/admin/auditoria'
    | '/admin/categorias'
    | '/admin/organizaciones'
    | '/admin/tags'
    | '/admin/usuarios'
    | '/insights/$id'
    | '/insights/'
    | '/admin/estudios/$id'
    | '/admin/estudios/nuevo'
    | '/admin/estudios/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/definir-contrasena'
    | '/entrar'
    | '/recuperar'
    | '/'
    | '/admin/auditoria'
    | '/admin/categorias'
    | '/admin/organizaciones'
    | '/admin/tags'
    | '/admin/usuarios'
    | '/insights/$id'
    | '/insights'
    | '/admin/estudios/$id'
    | '/admin/estudios/nuevo'
    | '/admin/estudios'
  id:
    | '__root__'
    | '/_auth'
    | '/definir-contrasena'
    | '/entrar'
    | '/recuperar'
    | '/_auth/'
    | '/_auth/admin/auditoria'
    | '/_auth/admin/categorias'
    | '/_auth/admin/organizaciones'
    | '/_auth/admin/tags'
    | '/_auth/admin/usuarios'
    | '/_auth/insights/$id'
    | '/_auth/insights/'
    | '/_auth/admin/estudios/$id'
    | '/_auth/admin/estudios/nuevo'
    | '/_auth/admin/estudios/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  DefinirContrasenaRoute: typeof DefinirContrasenaRoute
  EntrarRoute: typeof EntrarRoute
  RecuperarRoute: typeof RecuperarRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/definir-contrasena': {
      id: '/definir-contrasena'
      path: '/definir-contrasena'
      fullPath: '/definir-contrasena'
      preLoaderRoute: typeof DefinirContrasenaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recuperar': {
      id: '/recuperar'
      path: '/recuperar'
      fullPath: '/recuperar'
      preLoaderRoute: typeof RecuperarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/auditoria': {
      id: '/_auth/admin/auditoria'
      path: '/admin/auditoria'
      fullPath: '/admin/auditoria'
      preLoaderRoute: typeof AuthAdminAuditoriaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/categorias': {
      id: '/_auth/admin/categorias'
      path: '/admin/categorias'
      fullPath: '/admin/categorias'
      preLoaderRoute: typeof AuthAdminCategoriasRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/organizaciones': {
      id: '/_auth/admin/organizaciones'
      path: '/admin/organizaciones'
      fullPath: '/admin/organizaciones'
      preLoaderRoute: typeof AuthAdminOrganizacionesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/tags': {
      id: '/_auth/admin/tags'
      path: '/admin/tags'
      fullPath: '/admin/tags'
      preLoaderRoute: typeof AuthAdminTagsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/usuarios': {
      id: '/_auth/admin/usuarios'
      path: '/admin/usuarios'
      fullPath: '/admin/usuarios'
      preLoaderRoute: typeof AuthAdminUsuariosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/insights/': {
      id: '/_auth/insights/'
      path: '/insights'
      fullPath: '/insights/'
      preLoaderRoute: typeof AuthInsightsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/insights/$id': {
      id: '/_auth/insights/$id'
      path: '/insights/$id'
      fullPath: '/insights/$id'
      preLoaderRoute: typeof AuthInsightsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/estudios/': {
      id: '/_auth/admin/estudios/'
      path: '/admin/estudios'
      fullPath: '/admin/estudios/'
      preLoaderRoute: typeof AuthAdminEstudiosIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/estudios/$id': {
      id: '/_auth/admin/estudios/$id'
      path: '/admin/estudios/$id'
      fullPath: '/admin/estudios/$id'
      preLoaderRoute: typeof AuthAdminEstudiosIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/estudios/nuevo': {
      id: '/_auth/admin/estudios/nuevo'
      path: '/admin/estudios/nuevo'
      fullPath: '/admin/estudios/nuevo'
      preLoaderRoute: typeof AuthAdminEstudiosNuevoRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAdminAuditoriaRoute: typeof AuthAdminAuditoriaRoute
  AuthAdminCategoriasRoute: typeof AuthAdminCategoriasRoute
  AuthAdminOrganizacionesRoute: typeof AuthAdminOrganizacionesRoute
  AuthAdminTagsRoute: typeof AuthAdminTagsRoute
  AuthAdminUsuariosRoute: typeof AuthAdminUsuariosRoute
  AuthInsightsIdRoute: typeof AuthInsightsIdRoute
  AuthInsightsIndexRoute: typeof AuthInsightsIndexRoute
  AuthAdminEstudiosIdRoute: typeof AuthAdminEstudiosIdRoute
  AuthAdminEstudiosNuevoRoute: typeof AuthAdminEstudiosNuevoRoute
  AuthAdminEstudiosIndexRoute: typeof AuthAdminEstudiosIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthIndexRoute: AuthIndexRoute,
  AuthAdminAuditoriaRoute: AuthAdminAuditoriaRoute,
  AuthAdminCategoriasRoute: AuthAdminCategoriasRoute,
  AuthAdminOrganizacionesRoute: AuthAdminOrganizacionesRoute,
  AuthAdminTagsRoute: AuthAdminTagsRoute,
  AuthAdminUsuariosRoute: AuthAdminUsuariosRoute,
  AuthInsightsIdRoute: AuthInsightsIdRoute,
  AuthInsightsIndexRoute: AuthInsightsIndexRoute,
  AuthAdminEstudiosIdRoute: AuthAdminEstudiosIdRoute,
  AuthAdminEstudiosNuevoRoute: AuthAdminEstudiosNuevoRoute,
  AuthAdminEstudiosIndexRoute: AuthAdminEstudiosIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  DefinirContrasenaRoute: DefinirContrasenaRoute,
  EntrarRoute: EntrarRoute,
  RecuperarRoute: RecuperarRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
